import type { Case, Customer } from '../types/admin'

export const seedCustomers: Customer[] = [
  {
    id: 'c1',
    name: 'Mette Kruse',
    phone: '+45 26 44 12 08',
    email: 'mette.kruse@mail.dk',
    address: 'Hyldevej 12, 2650 Hvidovre',
    notes: 'Hund i haven — ring inden ankomst.',
  },
  {
    id: 'c2',
    name: 'Jonas Beck',
    phone: '+45 51 09 63 40',
    email: 'jonas.beck@mail.dk',
    address: 'Solvej 8, 2500 Valby',
    notes: '',
  },
  {
    id: 'c3',
    name: 'Nordbo Tandklinik',
    phone: '+45 33 18 44 02',
    email: 'kontakt@nordbotand.dk',
    address: 'Hovedvejen 12, 2600 Glostrup',
    notes: 'Arbejde skal udføres efter kl. 16.',
  },
  {
    id: 'c4',
    name: 'Ejerforeningen Bakken',
    phone: '+45 40 55 21 76',
    email: 'bestyrelsen@bakken4.dk',
    address: 'Bakkevej 4, 2400 København NV',
    notes: 'Kontakt formand Lars ved ændringer.',
  },
]

const photoBefore =
  'https://cdn.magicpatterns.com/patterns/generated-images/b96e7b42-c3f6-4c88-863e-95639bb573ba.jpg'
const photoAfter =
  'https://cdn.magicpatterns.com/patterns/generated-images/67a2ca28-a86b-4cf8-a3d1-78157f457ffb.jpg'
const photoWork =
  'https://cdn.magicpatterns.com/patterns/generated-images/3401c3c8-5a24-477b-8948-dfa5f775294a.jpg'

export const seedCases: Case[] = [
  {
    id: 'case-1',
    number: '0001',
    customerId: 'c1',
    title: 'Montering af hegn',
    address: 'Hyldevej 12, 2650 Hvidovre',
    description:
      'Nedtagning af 14 meter gammelt hegn og opsætning af nyt hegn i vandrette lameller. Låge mod haven.',
    category: 'Montage',
    priceModel: 'Fast pris',
    hourlyRate: '',
    fixedPrice: '6.500',
    estimate: '6.500',
    finalAmount: '',
    plannedDate: '2026-09-14',
    status: 'Planlagt',
    internalNotes: [
      { id: 'n1', text: 'Kunden ønsker arbejdet udført efter kl. 15.', createdAt: '2026-08-29T09:15:00' },
      { id: 'n2', text: 'Materialer bestilt hos tømmerhandel.', createdAt: '2026-08-30T07:40:00' },
    ],
    photos: [{ id: 'p1', url: photoBefore, name: 'gammelt-hegn.jpg', stage: 'Før' }],
    createdAt: '2026-08-24T10:12:00',
    fromWebsite: true,
  },
  {
    id: 'case-2',
    number: '0002',
    customerId: 'c3',
    title: 'Montage af inventar i klinik',
    address: 'Hovedvejen 12, 2600 Glostrup',
    description: 'Opsætning af skabe, hylder og TV-beslag i venteværelse og behandlingsrum.',
    category: 'Montage',
    priceModel: 'Fast pris',
    hourlyRate: '',
    fixedPrice: '18.900',
    estimate: '18.900',
    finalAmount: '',
    plannedDate: '',
    status: 'Tilbud sendt',
    internalNotes: [
      { id: 'n3', text: 'Tilbud sendt pr. mail 26. august. Følg op fredag.', createdAt: '2026-08-26T15:20:00' },
    ],
    photos: [],
    createdAt: '2026-08-22T13:05:00',
    fromWebsite: false,
  },
  {
    id: 'case-3',
    number: '0003',
    customerId: 'c2',
    title: 'Ophængning af køkkenskabe',
    address: 'Solvej 8, 2500 Valby',
    description: 'Fire overskabe skal hænges op, og en bordplade skal tilpasses omkring vindueskarm.',
    category: 'Multiservice',
    priceModel: 'Timepris',
    hourlyRate: '460',
    fixedPrice: '',
    estimate: '2.760',
    finalAmount: '',
    plannedDate: '2026-09-03',
    status: 'Accepteret',
    internalNotes: [],
    photos: [],
    createdAt: '2026-08-28T08:45:00',
    fromWebsite: true,
  },
  {
    id: 'case-4',
    number: '0004',
    customerId: 'c4',
    title: 'Vedligeholdelse af opgange',
    address: 'Bakkevej 4, 2400 København NV',
    description: 'Løbende vedligehold: udskiftning af pærer, justering af døre og småreparationer.',
    category: 'Vedligehold',
    priceModel: 'Timepris',
    hourlyRate: '460',
    fixedPrice: '',
    estimate: '3.900',
    finalAmount: '',
    plannedDate: '2026-09-02',
    status: 'I gang',
    internalNotes: [
      { id: 'n4', text: 'Nøgle til kælder ligger i skab ved indgang.', createdAt: '2026-08-27T11:00:00' },
    ],
    photos: [{ id: 'p2', url: photoWork, name: 'doerjustering.jpg', stage: 'Under arbejdet' }],
    createdAt: '2026-08-18T09:30:00',
    fromWebsite: false,
  },
  {
    id: 'case-5',
    number: '0005',
    customerId: 'c1',
    title: 'Reparation af terrassedør',
    address: 'Hyldevej 12, 2650 Hvidovre',
    description: 'Døren sluttede ikke tæt. Hængsler justeret og ny tætningsliste monteret.',
    category: 'Vedligehold',
    priceModel: 'Timepris',
    hourlyRate: '460',
    fixedPrice: '',
    estimate: '1.380',
    finalAmount: '1.380',
    plannedDate: '2026-08-11',
    status: 'Færdig',
    internalNotes: [],
    photos: [{ id: 'p3', url: photoAfter, name: 'efter.jpg', stage: 'Efter' }],
    createdAt: '2026-08-05T14:22:00',
    fromWebsite: false,
  },
  {
    id: 'case-6',
    number: '0006',
    customerId: 'c2',
    title: 'Udskiftning af hængsler',
    address: 'Solvej 8, 2500 Valby',
    description: 'Hængsler på 6 indvendige døre udskiftet.',
    category: 'Vedligehold',
    priceModel: 'Fast pris',
    hourlyRate: '',
    fixedPrice: '2.940',
    estimate: '2.940',
    finalAmount: '2.940',
    plannedDate: '2026-08-27',
    status: 'Faktureret',
    internalNotes: [],
    photos: [],
    createdAt: '2026-08-14T10:00:00',
    fromWebsite: false,
  },
  {
    id: 'case-7',
    number: '0007',
    customerId: 'c4',
    title: 'Opsætning af cykelstativ',
    address: 'Bakkevej 4, 2400 København NV',
    description: 'Nyt cykelstativ i gården skal monteres i fliser.',
    category: 'Montage',
    priceModel: 'Tilbud endnu ikke lavet',
    hourlyRate: '',
    fixedPrice: '',
    estimate: '',
    finalAmount: '',
    plannedDate: '',
    status: 'Ny henvendelse',
    internalNotes: [],
    photos: [],
    createdAt: '2026-08-30T07:55:00',
    fromWebsite: true,
  },
]
